import { TOGGLE_MODAL, UPDATE_MODAL_CONTENT } from '../actions/types';

const initialState = {
  status:           false,
  title:            null,
  content:          null,
  className:        null,
  actionButton:     {},
  cancelText:       null,
  closeAfterAction: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_MODAL: {
      const status = !state.status;
      if (status) {
        return { ...state, status };
      } else {
        return { ...initialState };
      }
    }
    case UPDATE_MODAL_CONTENT:
      return { ...state, ...payload };
    default:
      return state;
  }
}
